import { GLcourts } from '@debbie/common/dist/court/countries/greenland.js';
import { getDebtorsOnCustomer } from '@debbie/common/dist/customers/index.js';
import { isDocumentFoundation } from '@debbie/common/dist/documents/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { getMentionSuggestions, toEditorMentions, } from '@debbie/common/dist/templates/suggestions.js';
import { GLTribunalCaseType } from '@debbie/common/dist/tribunal/cases/countries/greenland.js';
import { GLTribunalJobType, defaultGLFogedBegaeringSagsfremstilling, } from '@debbie/common/dist/tribunal/jobs/countries/greenland.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { encodeText, parseText } from '../../../../utils/templates.js';
import Button from '../../../Button.js';
import NewEditor from '../../../editor/Editor.js';
import { htmlToPlainText } from '../../../editor/utils.js';
import Errors from '../../../Errors.js';
import File from '../../../File/index.js';
import CourtSelector from '../common/CourtSelector.js';
import EconomySettings from '../common/EconomySettings.js';
const Fogedbegaering = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const tenant = useTenant();
    const customerLoader = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.LETTER, propertyTypes || undefined, tenant);
    const tenantSagsfremstilling = tenant?.settings.tribunal?.caseTypes?.[GLTribunalCaseType.GLFogedBegaering]
        ?.sagsfremstilling;
    const [data, setData] = useState(props.resending
        ? {
            ...props.prefill,
            court: GLcourts.find((c) => c.courtId === props.prefill.courtId) ?? null,
            content: encodeText(props.prefill.emailHTML, mentionSuggestions),
        }
        : {
            courtFee: 30000,
            sendInfoToEconomyResponsible: true,
            economyResponsibleUserId: localStorage.getItem('economyResponsibleUserId'),
            addCourtFeeToClientBilling: false,
            addCourtFeeToCase: true,
            addCourtDisbursementToClientBilling: false,
            court: null,
            content: encodeText(tenantSagsfremstilling || defaultGLFogedBegaeringSagsfremstilling, mentionSuggestions),
        });
    const [content, newContent] = useState(data.content);
    useEffect(() => {
        if (customer) {
            const debtors = getDebtorsOnCustomer(customer);
            if (debtors.length > 0) {
                const debtor = debtors[0];
                if (debtor.details.courtId) {
                    const court = GLcourts.find((c) => c.id === debtor.details.courtId);
                    if (court) {
                        setData((s) => ({ ...s, court: court }));
                    }
                }
            }
        }
    }, [customer]);
    const foundations = documents &&
        documents.filter((document) => isDocumentFoundation(document) &&
            (document.signedFile || document.file));
    const foundation = foundations && foundations[0];
    const foundationFile = foundation && (foundation.signedFile || foundation.file);
    const getData = () => {
        if (data.court?.courtId == null) {
            throw new Error(`No court selected`);
        }
        if (foundation == null) {
            throw new Error(`No foundation`);
        }
        return {
            ...data,
            foundationDocumentId: foundation.documentId,
            courtId: data.court.courtId,
            emailHTML: parseText(data.content, mentionSuggestions),
            emailBody: htmlToPlainText(parseText(data.content, mentionSuggestions)),
        };
    };
    const submitter = useMutation(() => {
        const data = getData();
        console.log(data);
        if (singleCase?.caseId) {
            return tribunalAPI.createTribunalJob({
                type: props.resending
                    ? GLTribunalJobType.ResendFogedbegaering
                    : GLTribunalJobType.CreateFogedbegaering,
                tribunalCaseId: props.resending ? props.tribunalCaseId : undefined,
                data: data,
                caseId: singleCase?.caseId,
                reference: null,
            });
        }
    }, {
        onSuccess: () => {
            if (props.onCreated) {
                props.onCreated();
            }
        },
    });
    const canSubmit = data.court != null && foundationFile;
    return (React.createElement("div", null,
        React.createElement("h3", null, lang.tribunal.jurisdiction),
        React.createElement(CourtSelector, { courts: GLcourts, value: data.court, onChange: (court) => {
                setData((s) => ({ ...s, court }));
            } }),
        React.createElement("h3", null, "Email tekst"),
        React.createElement(NewEditor, { mentions: toEditorMentions(mentionSuggestions), onChange: (html) => setData((s) => ({ ...s, content: html })), initialContent: content }),
        React.createElement("h3", null, lang.tribunal.economy),
        React.createElement(EconomySettings, { value: data, onChange: (es) => setData((s) => ({ ...s, ...es })) }),
        React.createElement("h3", null, lang.tribunal.foundation),
        foundationFile ? (React.createElement(File, { file: foundationFile })) : (React.createElement("p", null, lang.tribunal.noFoundation)),
        submitter.isError && submitter.error instanceof Error && (React.createElement(Errors, { errors: [submitter.error.message] })),
        React.createElement(Button, { onClick: () => submitter.mutate(), loading: submitter.isLoading, block: true, disabled: !canSubmit }, lang.tribunal.createFogedrekvisition)));
};
export default Fogedbegaering;
//# sourceMappingURL=Fogedbegaering.js.map